(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6074],{

/***/ 66242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card_Card; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(63961);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/DefaultPropsProvider/DefaultPropsProvider.js
var DefaultPropsProvider = __webpack_require__(28628);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(90629);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Card/cardClasses.js


function getCardUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiCard', slot);
}
const cardClasses = (0,generateUtilityClasses/* default */.Z)('MuiCard', ['root']);
/* harmony default export */ var Card_cardClasses = ((/* unused pure expression or super */ null && (cardClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Card/Card.js
'use client';



const _excluded = ["className", "raised"];










const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getCardUtilityClass, classes);
};
const CardRoot = (0,styled/* default */.ZP)(Paper/* default */.Z, {
  name: 'MuiCard',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    overflow: 'hidden'
  };
});
const Card = /*#__PURE__*/react.forwardRef(function Card(inProps, ref) {
  const props = (0,DefaultPropsProvider/* useDefaultProps */.i)({
    props: inProps,
    name: 'MuiCard'
  });
  const {
      className,
      raised = false
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    raised
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx/* default */.Z)(classes.root, className),
    elevation: raised ? 8 : undefined,
    ref: ref,
    ownerState: ownerState
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Card_Card = (Card);

/***/ }),

/***/ 90629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Paper_Paper; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(63961);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/system/colorManipulator.js
var colorManipulator = __webpack_require__(2101);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
;// CONCATENATED MODULE: ./node_modules/@mui/material/styles/getOverlayAlpha.js
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const getOverlayAlpha = elevation => {
  let alphaValue;
  if (elevation < 1) {
    alphaValue = 5.11916 * elevation ** 2;
  } else {
    alphaValue = 4.5 * Math.log(elevation + 1) + 2;
  }
  return (alphaValue / 100).toFixed(2);
};
/* harmony default export */ var styles_getOverlayAlpha = (getOverlayAlpha);
// EXTERNAL MODULE: ./node_modules/@mui/material/DefaultPropsProvider/DefaultPropsProvider.js
var DefaultPropsProvider = __webpack_require__(28628);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Paper/paperClasses.js


function getPaperUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiPaper', slot);
}
const paperClasses = (0,generateUtilityClasses/* default */.Z)('MuiPaper', ['root', 'rounded', 'outlined', 'elevation', 'elevation0', 'elevation1', 'elevation2', 'elevation3', 'elevation4', 'elevation5', 'elevation6', 'elevation7', 'elevation8', 'elevation9', 'elevation10', 'elevation11', 'elevation12', 'elevation13', 'elevation14', 'elevation15', 'elevation16', 'elevation17', 'elevation18', 'elevation19', 'elevation20', 'elevation21', 'elevation22', 'elevation23', 'elevation24']);
/* harmony default export */ var Paper_paperClasses = ((/* unused pure expression or super */ null && (paperClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Paper/Paper.js
'use client';



const _excluded = ["className", "component", "elevation", "square", "variant"];













const useUtilityClasses = ownerState => {
  const {
    square,
    elevation,
    variant,
    classes
  } = ownerState;
  const slots = {
    root: ['root', variant, !square && 'rounded', variant === 'elevation' && `elevation${elevation}`]
  };
  return (0,composeClasses/* default */.Z)(slots, getPaperUtilityClass, classes);
};
const PaperRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiPaper',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], !ownerState.square && styles.rounded, ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]];
  }
})(({
  theme,
  ownerState
}) => {
  var _theme$vars$overlays;
  return (0,esm_extends/* default */.Z)({
    backgroundColor: (theme.vars || theme).palette.background.paper,
    color: (theme.vars || theme).palette.text.primary,
    transition: theme.transitions.create('box-shadow')
  }, !ownerState.square && {
    borderRadius: theme.shape.borderRadius
  }, ownerState.variant === 'outlined' && {
    border: `1px solid ${(theme.vars || theme).palette.divider}`
  }, ownerState.variant === 'elevation' && (0,esm_extends/* default */.Z)({
    boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
  }, !theme.vars && theme.palette.mode === 'dark' && {
    backgroundImage: `linear-gradient(${(0,colorManipulator/* alpha */.Fq)('#fff', styles_getOverlayAlpha(ownerState.elevation))}, ${(0,colorManipulator/* alpha */.Fq)('#fff', styles_getOverlayAlpha(ownerState.elevation))})`
  }, theme.vars && {
    backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
  }));
});
const Paper = /*#__PURE__*/react.forwardRef(function Paper(inProps, ref) {
  const props = (0,DefaultPropsProvider/* useDefaultProps */.i)({
    props: inProps,
    name: 'MuiPaper'
  });
  const {
      className,
      component = 'div',
      elevation = 1,
      square = false,
      variant = 'elevation'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component,
    elevation,
    square,
    variant
  });
  const classes = useUtilityClasses(ownerState);
  if (false) {}
  return /*#__PURE__*/(0,jsx_runtime.jsx)(PaperRoot, (0,esm_extends/* default */.Z)({
    as: component,
    ownerState: ownerState,
    className: (0,clsx/* default */.Z)(classes.root, className),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Paper_Paper = (Paper);

/***/ }),

/***/ 2734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTheme; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96682);
/* harmony import */ var _defaultTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90247);
/* harmony import */ var _identifier__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10606);
'use client';





function useTheme() {
  const theme = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_defaultTheme__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);
  if (false) {}
  return theme[_identifier__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z] || theme;
}

/***/ }),

/***/ 61730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMediaQuery; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_utils_useEnhancedEffect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73546);
/* harmony import */ var _useThemeProps__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20539);
/* harmony import */ var _useThemeWithoutDefault__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34168);
'use client';






/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */

/**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */

/**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */

function useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
  const [match, setMatch] = react__WEBPACK_IMPORTED_MODULE_0__.useState(() => {
    if (noSsr && matchMedia) {
      return matchMedia(query).matches;
    }
    if (ssrMatchMedia) {
      return ssrMatchMedia(query).matches;
    }

    // Once the component is mounted, we rely on the
    // event listeners to return the correct matches value.
    return defaultMatches;
  });
  (0,_mui_utils_useEnhancedEffect__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(() => {
    let active = true;
    if (!matchMedia) {
      return undefined;
    }
    const queryList = matchMedia(query);
    const updateMatch = () => {
      // Workaround Safari wrong implementation of matchMedia
      // TODO can we remove it?
      // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
      if (active) {
        setMatch(queryList.matches);
      }
    };
    updateMatch();
    // TODO: Use `addEventListener` once support for Safari < 14 is dropped
    queryList.addListener(updateMatch);
    return () => {
      active = false;
      queryList.removeListener(updateMatch);
    };
  }, [query, matchMedia]);
  return match;
}

// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const maybeReactUseSyncExternalStore = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useSyncExternalStore' + ''];
function useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
  const getDefaultSnapshot = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(() => defaultMatches, [defaultMatches]);
  const getServerSnapshot = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    if (noSsr && matchMedia) {
      return () => matchMedia(query).matches;
    }
    if (ssrMatchMedia !== null) {
      const {
        matches
      } = ssrMatchMedia(query);
      return () => matches;
    }
    return getDefaultSnapshot;
  }, [getDefaultSnapshot, query, ssrMatchMedia, noSsr, matchMedia]);
  const [getSnapshot, subscribe] = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    if (matchMedia === null) {
      return [getDefaultSnapshot, () => () => {}];
    }
    const mediaQueryList = matchMedia(query);
    return [() => mediaQueryList.matches, notify => {
      // TODO: Use `addEventListener` once support for Safari < 14 is dropped
      mediaQueryList.addListener(notify);
      return () => {
        mediaQueryList.removeListener(notify);
      };
    }];
  }, [getDefaultSnapshot, matchMedia, query]);
  const match = maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  return match;
}
function useMediaQuery(queryInput, options = {}) {
  const theme = (0,_useThemeWithoutDefault__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  // Wait for jsdom to support the match media feature.
  // All the browsers MUI support have this built-in.
  // This defensive check is here for simplicity.
  // Most of the time, the match media logic isn't central to people tests.
  const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
  const {
    defaultMatches = false,
    matchMedia = supportMatchMedia ? window.matchMedia : null,
    ssrMatchMedia = null,
    noSsr = false
  } = (0,_useThemeProps__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    name: 'MuiUseMediaQuery',
    props: options,
    theme
  });
  if (false) {}
  let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
  query = query.replace(/^@media( ?)/m, '');

  // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
  const useMediaQueryImplementation = maybeReactUseSyncExternalStore !== undefined ? useMediaQueryNew : useMediaQueryOld;
  const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
  if (false) {}
  return match;
}

/***/ }),

/***/ 96682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export systemDefaultTheme */
/* harmony import */ var _createTheme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17172);
/* harmony import */ var _useThemeWithoutDefault__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34168);
'use client';



const systemDefaultTheme = (0,_createTheme__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
function useTheme(defaultTheme = systemDefaultTheme) {
  return (0,_useThemeWithoutDefault__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(defaultTheme);
}
/* harmony default export */ __webpack_exports__["Z"] = (useTheme);

/***/ }),

/***/ 20539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getThemeProps; }
/* harmony export */ });
/* harmony import */ var _mui_utils_resolveProps__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35971);

function getThemeProps(params) {
  const {
    theme,
    name,
    props
  } = params;
  if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) {
    return props;
  }
  return (0,_mui_utils_resolveProps__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(theme.components[name].defaultProps, props);
}

/***/ }),

/***/ 34168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_styled_engine__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87685);
'use client';



function isObjectEmpty(obj) {
  return Object.keys(obj).length === 0;
}
function useTheme(defaultTheme = null) {
  const contextTheme = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_mui_styled_engine__WEBPACK_IMPORTED_MODULE_1__.T);
  return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
/* harmony default export */ __webpack_exports__["Z"] = (useTheme);

/***/ }),

/***/ 73546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */
const useEnhancedEffect = typeof window !== 'undefined' ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
/* harmony default export */ __webpack_exports__["Z"] = (useEnhancedEffect);

/***/ }),

/***/ 6074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61906);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34745);
/* harmony import */ var src_api_dashboard__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95629);
/* harmony import */ var src_core_components_chat_history__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15793);
/* harmony import */ var src_components_EmptyState__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72994);
/* harmony import */ var src_hooks_useDeviceScopedInit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82017);
/* harmony import */ var src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26771);
/* harmony import */ var src_utils_dateRangeParams__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31909);











const API_BY_MODE = {
    ios: src_api_dashboard__WEBPACK_IMPORTED_MODULE_5__/* .getAllDashboard */ .gP,
    "android-local": src_api_dashboard__WEBPACK_IMPORTED_MODULE_5__/* .getLocalAndroidAll */ .gH,
    "android-cloud": src_api_dashboard__WEBPACK_IMPORTED_MODULE_5__/* .getGcloudAll */ .U1
};
/**
 * 按平台解析请求所需的 username / deviceUdid。
 * @param {'ios'|'android-local'|'android-cloud'} mode
 * @param {Object} context - deviceContext
 * @returns {{ username: string, deviceUdid: string }}
 */ const resolveRequestContext = (mode, context)=>{
    if (mode === "android-local") {
        return {
            username: (0,src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_10__/* .readUserEmail */ .t)(),
            deviceUdid: (0,src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_10__/* .readLocalDeviceUdid */ .S)(context)
        };
    }
    return {
        username: (context === null || context === void 0 ? void 0 : context.username) || "",
        deviceUdid: (context === null || context === void 0 ? void 0 : context.physicalDeviceKey) || ""
    };
};
/**
 * Shared page for AI chat history (ChatGPT / Gemini / …)
 * Category comes from sidebar route; mode picks the dashboard API.
 */ const AiChatHistoryPage = (param)=>{
    let { category , title , mode ="ios"  } = param;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("common");
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    const isDisconnect = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)((state)=>state.Common.isDisconnect);
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const [sessions, setSessions] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [loadError, setLoadError] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [hasDevice, setHasDevice] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const scopeRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null) // 当前设备作用域，用于日期变化时重拉
    ;
    const dateRangeRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)({}) // { startTime, endTime }，空对象 = 不筛选
    ;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const tabTitle = t(title) || title;
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_4__/* .setCurrentTab */ .Lw)(tabTitle));
        return ()=>dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_4__/* .setCurrentTab */ .Lw)(""));
    }, [
        dispatch,
        t,
        title
    ]);
    // 拉取会话列表（设备切换、日期筛选共用）
    const load = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(async (param)=>{
        let { context , signal , isCurrent  } = param;
        setLoading(true);
        setLoadError(false);
        const fetchApi = API_BY_MODE[mode] || src_api_dashboard__WEBPACK_IMPORTED_MODULE_5__/* .getAllDashboard */ .gP;
        const { username , deviceUdid  } = resolveRequestContext(mode, context);
        if (!isCurrent()) return;
        setHasDevice(Boolean(deviceUdid));
        try {
            var ref;
            const response = await fetchApi({
                username,
                params: {
                    category,
                    offset: 0,
                    limit: 100,
                    deviceUdid,
                    ...dateRangeRef.current
                }
            }, {
                signal
            });
            if (mode === "ios" && username != null && "advanced" in (response || {})) {
                dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_4__/* .changeExtremeService */ .xU)([
                    "true",
                    true
                ].includes(response === null || response === void 0 ? void 0 : response.advanced)));
            }
            if (!isCurrent()) return;
            const contents = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.contents;
            setSessions(contents && Array.isArray(contents) && contents.length > 0 ? (0,src_core_components_chat_history__WEBPACK_IMPORTED_MODULE_6__/* .mapAuthContentsToSessions */ .Iq)(contents, category) : []);
        } catch (e) {
            if (!isCurrent() || (e === null || e === void 0 ? void 0 : e.code) === "ERR_CANCELED") return;
            setSessions([]);
            setLoadError(true);
        } finally{
            if (isCurrent()) setLoading(false);
        }
    }, [
        category,
        dispatch,
        mode
    ]);
    // 设备切换时重置会话列表、清空日期筛选并重新拉取
    (0,src_hooks_useDeviceScopedInit__WEBPACK_IMPORTED_MODULE_8__/* .useDeviceScopedInit */ .A)((0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((_, scope)=>{
        scopeRef.current = scope;
        dateRangeRef.current = {};
        load(scope);
    }, [
        load
    ]));
    // 日期筛选：带 startTime/endTime 重新请求接口（不是只筛已加载的数据）
    const handleDateChange = (value)=>{
        dateRangeRef.current = value ? (0,src_utils_dateRangeParams__WEBPACK_IMPORTED_MODULE_9__/* .buildTimeParams */ .W2)([
            value,
            value
        ]) : {};
        const scope = scopeRef.current;
        if (scope) load(scope);
    };
    const emptyType = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (isDisconnect || !hasDevice) return src_components_EmptyState__WEBPACK_IMPORTED_MODULE_7__/* .EMPTY_TYPES.DEVICE_NOT_CONNECTED */ .j.DEVICE_NOT_CONNECTED;
        if (loadError) return src_components_EmptyState__WEBPACK_IMPORTED_MODULE_7__/* .EMPTY_TYPES.SYNC_FAILED */ .j.SYNC_FAILED;
        return src_components_EmptyState__WEBPACK_IMPORTED_MODULE_7__/* .EMPTY_TYPES.NO_DATA */ .j.NO_DATA;
    }, [
        hasDevice,
        isDisconnect,
        loadError
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_core_components_chat_history__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
        sessions: sessions,
        loading: loading,
        emptyType: emptyType,
        onDateChange: handleDateChange
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AiChatHistoryPage);


/***/ }),

/***/ 15793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Q": function() { return /* binding */ AI_CATEGORIES; },
/* harmony export */   "Iq": function() { return /* binding */ mapAuthContentsToSessions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Card__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(66242);
/* harmony import */ var _mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(61730);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(90948);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2734);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(15378);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _iconify_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1954);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61906);
/* harmony import */ var src_components_EmptyState__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72994);
/* harmony import */ var _chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(18023);
/* harmony import */ var _chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(74743);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-picker-input > input {\n    color: var(--02484-b-60, #484b60) !important;\n    font-family: Poppins, sans-serif !important;\n    font-size: 14px !important;\n    font-style: normal !important;\n    font-weight: 400 !important;\n    line-height: 22px !important;\n    text-align: left !important;\n  }\n\n  .ant-picker-input > input::placeholder {\n    color: #bfbfbf !important;\n  }\n\n  .ant-picker-suffix {\n    opacity: 1 !important;\n    color: var(--02484-b-60, #484b60);\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}













const CustomDatePicker = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_templateObject());

const AI_CATEGORIES = {
    CHATGPT: "CHATGPT",
    GEMINI: "GEMINI",
    DEEPSEEK: "DEEPSEEK",
    CLAUDE: "CLAUDE",
    PERPLEXITY: "PERPLEXITY",
    COPILOT: "COPILOT",
    POE: "POE",
    CHARACTER_AI: "CHARACTER_AI",
    PI_AI: "PI_AI"
};
const ASSISTANT_LABEL = {
    CHATGPT: "ChatGPT",
    GEMINI: "Gemini",
    DEEPSEEK: "DeepSeek",
    CLAUDE: "Claude",
    PERPLEXITY: "Perplexity",
    COPILOT: "Copilot",
    POE: "Poe",
    CHARACTER_AI: "Character.AI",
    PI_AI: "Pi"
};
/** Map /dashboard/auth/all contents → session list items */ const mapAuthContentsToSessions = function() {
    let contents = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], category = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "CHATGPT";
    if (!Array.isArray(contents)) return [];
    return contents.map((item, index)=>{
        const ts = Number(item.time);
        const time = Number.isFinite(ts) ? dayjs__WEBPACK_IMPORTED_MODULE_3___default()(ts) : dayjs__WEBPACK_IMPORTED_MODULE_3___default()();
        const input = item.input_text || "";
        const output = item.output_text || "";
        const assistantName = ASSISTANT_LABEL[category] || category;
        return {
            id: "".concat(category, "-").concat(ts || index, "-").concat(index),
            title: input || output || assistantName,
            listDate: time.format("YYYY/M/D"),
            userName: "User",
            assistantName,
            userMessage: input,
            assistantMessage: output,
            timestamp: time.format("YYYY-MM-DD HH:mm:ss"),
            category,
            app: item.app || ""
        };
    });
};
/**
 * Universal Chat History layout
 * - PC: left session list + right one user msg / one AI reply
 * - Mobile: list first → tap item → detail
 */ const ChatHistory = (param)=>{
    let { sessions =[] , categories =[] , activeCategory , onCategoryChange , loading =false , searchPlaceholder , emptyType =src_components_EmptyState__WEBPACK_IMPORTED_MODULE_7__/* .EMPTY_TYPES.NO_DATA */ .j.NO_DATA , className ="" , onDateChange  } = param;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)("common");
    const theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)();
    const mdAbove = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(theme.breakpoints.up("md"));
    const [search, setSearch] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [filterDate, setFilterDate] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null);
    const [selectedId, setSelectedId] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null);
    const [mobileShowDetail, setMobileShowDetail] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        var ref;
        var ref1;
        setSelectedId((ref1 = (ref = sessions[0]) === null || ref === void 0 ? void 0 : ref.id) !== null && ref1 !== void 0 ? ref1 : null);
        setMobileShowDetail(false);
    }, [
        sessions
    ]);
    const filteredSessions = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        const keyword = search.trim().toLowerCase();
        return sessions.filter((item)=>{
            const matchSearch = !keyword || (item.title || "").toLowerCase().includes(keyword) || (item.userMessage || "").toLowerCase().includes(keyword) || (item.assistantMessage || "").toLowerCase().includes(keyword);
            // 上层接管日期筛选时（onDateChange），列表已由接口按日期返回，这里不再本地按天过滤
            if (!filterDate || onDateChange) return matchSearch;
            return matchSearch && dayjs__WEBPACK_IMPORTED_MODULE_3___default()(item.timestamp).isSame(filterDate, "day");
        });
    }, [
        sessions,
        search,
        filterDate,
        onDateChange
    ]);
    const selected = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>filteredSessions.find((item)=>item.id === selectedId) || filteredSessions[0] || null, [
        filteredSessions,
        selectedId
    ]);
    const handleSelect = (id)=>{
        setSelectedId(id);
        if (!mdAbove) setMobileShowDetail(true);
    };
    // 日期变化：通知上层带 startTime/endTime 重新请求接口
    const applyDate = (value)=>{
        setFilterDate(value || null);
        onDateChange === null || onDateChange === void 0 ? void 0 : onDateChange(value || null);
    };
    const handlePrevDay = ()=>{
        applyDate((filterDate || dayjs__WEBPACK_IMPORTED_MODULE_3___default()()).subtract(1, "day"));
    };
    const handleNextDay = ()=>{
        applyDate((filterDate || dayjs__WEBPACK_IMPORTED_MODULE_3___default()()).add(1, "day"));
    };
    const placeholder = searchPlaceholder || (mdAbove ? t("Search Browser History") || "Search Browser History" : t("Search") || "Search");
    const renderCategories = ()=>{
        if (!categories.length) return null;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().categoryRow),
            children: categories.map((cat)=>{
                const active = cat.category === activeCategory;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
                    type: "button",
                    className: "".concat((_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().categoryItem), " ").concat(active ? (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().categoryItemActive) : ""),
                    onClick: ()=>{
                        return onCategoryChange === null || onCategoryChange === void 0 ? void 0 : onCategoryChange(cat.category);
                    },
                    children: [
                        cat.icon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                            src: cat.icon,
                            width: 22,
                            height: 22,
                            alt: cat.name
                        }) : cat.iconify ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                            icon: cat.iconify,
                            width: 18,
                            height: 18
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                            className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().categoryDot)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                            children: cat.name
                        })
                    ]
                }, cat.category);
            })
        });
    };
    const renderSearch = function() /*#__PURE__*/ {
        let extraClass = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "".concat((_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().searchBox), " ").concat(extraClass),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                    value: search,
                    onChange: (e)=>setSearch(e.target.value),
                    placeholder: placeholder,
                    className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().searchInput)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
                    className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().searchIcon),
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "20",
                    height: "20",
                    viewBox: "0 0 20 20",
                    fill: "none",
                    "aria-hidden": true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M8.90039 3.49072C12.2141 3.49072 14.9004 6.17701 14.9004 9.49072C14.9004 10.5198 14.6411 11.4881 14.1846 12.3345L16.7969 14.7739C17.2005 15.1509 17.2005 15.7622 16.7969 16.1392L16.7031 16.2261L16.625 16.2935C16.219 16.6023 15.6195 16.5793 15.2412 16.2261L12.8564 13.9985C11.8001 14.9262 10.4167 15.4907 8.90039 15.4907C5.58682 15.4906 2.90039 12.8043 2.90039 9.49072C2.90039 6.17712 5.58682 3.49089 8.90039 3.49072ZM8.90039 4.99072C6.41525 4.99089 4.40039 7.00554 4.40039 9.49072C4.40039 11.9759 6.41525 13.9906 8.90039 13.9907C10.2777 13.9907 11.5095 13.3708 12.335 12.396C12.3505 12.375 12.3673 12.3546 12.3848 12.3345L12.3994 12.3188C13.025 11.5459 13.4004 10.5625 13.4004 9.49072C13.4004 7.00544 11.3857 4.99072 8.90039 4.99072Z",
                        fill: "#6B6F88"
                    })
                })
            ]
        });
    };
    const renderDatePicker = function() /*#__PURE__*/ {
        let withArrows = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().dateGroup),
            children: [
                withArrows && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                    type: "button",
                    className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().dateArrow),
                    onClick: handlePrevDay,
                    "aria-label": "previous day",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                        icon: "mdi:chevron-left",
                        width: 22
                    })
                }),
                withArrows ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomDatePicker, {
                    value: filterDate,
                    onChange: applyDate,
                    allowClear: true,
                    inputReadOnly: true,
                    format: "YYYY-MM-DD",
                    placeholder: "YYYY-MM-DD",
                    className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().datePicker),
                    prefix: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                        icon: "mdi:calendar-month-outline",
                        width: 18,
                        className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().dateIcon)
                    }),
                    suffixIcon: null
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().mobileDatePickerWrap),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomDatePicker, {
                            value: filterDate,
                            onChange: applyDate,
                            allowClear: false,
                            inputReadOnly: true,
                            format: "YYYY-MM-DD",
                            placeholder: "YYYY-MM-DD",
                            className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().datePicker),
                            prefix: null,
                            suffixIcon: null
                        }),
                        filterDate ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                            type: "button",
                            className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().mobileDateAction),
                            onClick: ()=>applyDate(null),
                            "aria-label": "clear date",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                                icon: "mdi:close",
                                width: 18,
                                className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().dateIcon)
                            })
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                            className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().mobileDateIcon),
                            "aria-hidden": true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                                icon: "mdi:calendar-month-outline",
                                width: 18,
                                className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().dateIcon)
                            })
                        })
                    ]
                }),
                withArrows && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                    type: "button",
                    className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().dateArrow),
                    onClick: handleNextDay,
                    "aria-label": "next day",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                        icon: "mdi:chevron-right",
                        width: 22
                    })
                })
            ]
        });
    };
    const renderList = ()=>{
        if (loading) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {});
        }
        if (filteredSessions.length === 0) {
            return null;
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ul", {
            className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().list),
            children: filteredSessions.map((item)=>{
                const active = (selected === null || selected === void 0 ? void 0 : selected.id) === item.id;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
                    className: "".concat((_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().listItem), " ").concat(active ? (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().listItemActive) : ""),
                    onClick: ()=>handleSelect(item.id),
                    role: "button",
                    tabIndex: 0,
                    onKeyDown: (e)=>{
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            handleSelect(item.id);
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                            className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().listTitle),
                            children: item.title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                            className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().listDate),
                            children: item.listDate
                        })
                    ]
                }, item.id);
            })
        });
    };
    const renderMessages = (session)=>{
        if (loading) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {});
        }
        if (!session) {
            if (filteredSessions.length === 0) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_EmptyState__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    type: emptyType || src_components_EmptyState__WEBPACK_IMPORTED_MODULE_7__/* .EMPTY_TYPES.NO_DATA */ .j.NO_DATA,
                    className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().emptyState)
                });
            }
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().emptyWrap)
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().messageList),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "".concat((_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().messageRow), " ").concat((_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().messageRight)),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().sender),
                            children: session.userName
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "".concat((_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().bubble), " ").concat((_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().bubbleUser)),
                            children: session.userMessage
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().timestamp),
                            children: session.timestamp
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "".concat((_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().messageRow), " ").concat((_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().messageLeft)),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().sender),
                            children: session.assistantName
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "".concat((_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().bubble), " ").concat((_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().bubbleAssistant)),
                            children: session.assistantMessage
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().timestamp),
                            children: session.timestamp
                        })
                    ]
                })
            ]
        });
    };
    const heightClass = "Bxl:h-[calc(var(--vh2)*100-90px)] Bxl:max-h-[calc(var(--vh2)*100-90px)] Bxls:Headers5:h-[calc(var(--vh2)*100-145px)] Bxls:Headers5:max-h-[calc(var(--vh2)*100-145px)] Header5:big:h-[calc(var(--vh2)*100-210px)] Header5:big:max-h-[calc(var(--vh2)*100-210px)] bigs:h-[calc(var(--vh2)*100-270px)] bigs:max-h-[calc(var(--vh2)*100-270px)]";
    // —— Mobile: list view ——
    if (!mdAbove && !mobileShowDetail) {
        const hasNoFilteredResults = !loading && filteredSessions.length === 0;
        const showFullEmpty = hasNoFilteredResults && sessions.length === 0;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material_Card__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
            className: "".concat((_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().root), " ").concat(heightClass, " ").concat(className),
            children: [
                !showFullEmpty ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().mobileToolbar),
                    children: [
                        renderSearch((_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().searchGrow)),
                        renderDatePicker(false)
                    ]
                }) : null,
                showFullEmpty ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_EmptyState__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    type: emptyType || src_components_EmptyState__WEBPACK_IMPORTED_MODULE_7__/* .EMPTY_TYPES.NO_DATA */ .j.NO_DATA,
                    className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().emptyState)
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        renderCategories(),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().mobileListBody),
                            children: hasNoFilteredResults ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_EmptyState__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                type: emptyType || src_components_EmptyState__WEBPACK_IMPORTED_MODULE_7__/* .EMPTY_TYPES.NO_DATA */ .j.NO_DATA,
                                className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().emptyState)
                            }) : renderList()
                        })
                    ]
                })
            ]
        });
    }
    // —— Mobile: detail view ——
    if (!mdAbove && mobileShowDetail) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material_Card__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
            className: "".concat((_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().root), " ").concat(heightClass, " ").concat(className),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().mobileDetailHeader),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                        type: "button",
                        className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().backBtn),
                        onClick: ()=>setMobileShowDetail(false),
                        "aria-label": "back",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                            icon: "mdi:chevron-left",
                            width: 24
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().detailBody),
                    children: renderMessages(selected)
                })
            ]
        });
    }
    // —— PC: top toolbar + bottom split ——
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material_Card__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
        className: "".concat((_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().root), " ").concat(heightClass, " ").concat(className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().pcToolbar),
                children: [
                    renderSearch(),
                    renderDatePicker(true)
                ]
            }),
            renderCategories(),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().pcLayout),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("aside", {
                        className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().sidebar),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().sidebarBody),
                            children: renderList()
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
                        className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().main),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: (_chat_history_module_scss__WEBPACK_IMPORTED_MODULE_13___default().detailBody),
                            children: renderMessages(selected)
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (ChatHistory);


/***/ }),

/***/ 74743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74249);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__);




const ContentLoading = (param)=>{
    let { label , fullScreen =false , className =""  } = param;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    const text = label || t("Loading...");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        role: "status",
        "aria-live": "polite",
        "aria-label": text,
        className: "".concat((_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRoot), " ").concat(fullScreen ? (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRootFullScreen) : "", " ").concat(className).trim(),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: "/images/loading/spinner.svg",
                alt: "",
                width: 64,
                height: 64,
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingSpinner),
                "aria-hidden": "true",
                priority: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingLabel),
                children: text
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentLoading);


/***/ }),

/***/ 72994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ EMPTY_TYPES; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);



const EMPTY_TYPES = {
    SYNC_FAILED: "syncFailed",
    DEVICE_NOT_CONNECTED: "deviceNotConnected",
    NO_DATA: "noData"
};
const EMPTY_STATE_MAP = {
    [EMPTY_TYPES.SYNC_FAILED]: {
        icon: "/image/synchronizationfailed.svg",
        labelKey: "Synchronization failed"
    },
    [EMPTY_TYPES.DEVICE_NOT_CONNECTED]: {
        icon: "/image/devicenotconnected.svg",
        labelKey: "Device not connected"
    },
    [EMPTY_TYPES.NO_DATA]: {
        icon: "/image/nodataavailable..svg",
        labelKey: "No data available."
    }
};
const EmptyState = (param)=>{
    let { type =EMPTY_TYPES.NO_DATA , className =""  } = param;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    const state = EMPTY_STATE_MAP[type] || EMPTY_STATE_MAP[EMPTY_TYPES.NO_DATA];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-1 flex-col items-center justify-center w-full h-full min-h-0 text-center px-4 py-6 ".concat(className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: state.icon,
                width: 135,
                height: 113,
                alt: "",
                priority: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "mt-4 mb-0 text-[14px] leading-[22px] font-normal font-[Poppins] text-[#484B60]",
                children: t(state.labelKey) || state.labelKey
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EmptyState);


/***/ }),

/***/ 82017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useDeviceScopedInit; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34745);



/**

 * 当前选中设备变化时重新执行初始化逻辑（拉数、重置本地 state 等）。

 * 通过 requestKey 与 AbortSignal 丢弃切换前未完成的异步请求。

 *

 * @param {(deviceUser: string, scope: {

 *   context: Object,

 *   signal: AbortSignal,

 *   isCurrent: () => boolean

 * }) => void} initFn - 设备作用域初始化回调，需 useCallback 包裹

 */ function useDeviceScopedInit(initFn) {
    const deviceUser = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)((state)=>state.Common.deviceUser);
    const context = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__/* .selectDeviceContext */ .VQ);
    const requestKey = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__/* .selectDeviceRequestKey */ .rx);
    const contextRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(context);
    contextRef.current = context;
    const effectiveDeviceUser = deviceUser || (context === null || context === void 0 ? void 0 : context.accountId) || (context === null || context === void 0 ? void 0 : context.username);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!effectiveDeviceUser) return;
        const controller = new AbortController();
        let active = true;
        const scopedContext = contextRef.current;
        // 仅当 requestKey 仍与当前 Redux 一致时，才应用异步结果
        const isCurrent = ()=>{
            var ref;
            return active && !controller.signal.aborted && ((ref = contextRef.current) === null || ref === void 0 ? void 0 : ref.requestKey) === requestKey;
        };
        initFn(effectiveDeviceUser, {
            context: scopedContext,
            signal: controller.signal,
            isCurrent
        });
        return ()=>{
            active = false;
            controller.abort();
        };
    }, [
        effectiveDeviceUser,
        initFn,
        requestKey
    ]);
}


/***/ }),

/***/ 74249:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentLoadingRoot":"ContentLoading_contentLoadingRoot__ypzGH","contentLoadingRootFullScreen":"ContentLoading_contentLoadingRootFullScreen__ZmB8e","contentLoadingSpinner":"ContentLoading_contentLoadingSpinner__4vCxU","content-loading-spin":"ContentLoading_content-loading-spin__K0YUP","contentLoadingLabel":"ContentLoading_contentLoadingLabel__S0w79"};

/***/ }),

/***/ 18023:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"chat-history_root__CYPJ5","pcToolbar":"chat-history_pcToolbar__7x8lW","searchBox":"chat-history_searchBox__plcnt","pcLayout":"chat-history_pcLayout__eMFUx","sidebar":"chat-history_sidebar___ULqn","categoryRow":"chat-history_categoryRow__GFyvd","categoryItem":"chat-history_categoryItem__xvO74","categoryItemActive":"chat-history_categoryItemActive__C6Y9n","categoryDot":"chat-history_categoryDot__OTMlr","sidebarBody":"chat-history_sidebarBody__pvohj","main":"chat-history_main__q4Mrp","detailBody":"chat-history_detailBody__2MW_S","searchGrow":"chat-history_searchGrow__Ep9Hh","searchIcon":"chat-history_searchIcon__hVsxq","searchInput":"chat-history_searchInput__OmGGI","dateGroup":"chat-history_dateGroup__SCxzN","dateArrow":"chat-history_dateArrow__pVpgK","dateIcon":"chat-history_dateIcon__aPKbe","datePicker":"chat-history_datePicker__EVTzU","mobileDatePickerWrap":"chat-history_mobileDatePickerWrap__LEW2m","mobileDateIcon":"chat-history_mobileDateIcon__G51d_","mobileDateAction":"chat-history_mobileDateAction__ouK4_","list":"chat-history_list__i_FYd","listItem":"chat-history_listItem___u1x4","listItemActive":"chat-history_listItemActive__50HWV","listTitle":"chat-history_listTitle__uwc3t","listDate":"chat-history_listDate__11lOA","messageList":"chat-history_messageList___Y7CB","messageRow":"chat-history_messageRow__IkJ0m","messageLeft":"chat-history_messageLeft__HO86D","messageRight":"chat-history_messageRight__eFSrj","sender":"chat-history_sender__hgCMt","bubble":"chat-history_bubble___IyMM","bubbleAssistant":"chat-history_bubbleAssistant__7F23n","bubbleUser":"chat-history_bubbleUser__pWIfB","timestamp":"chat-history_timestamp__npuw8","emptyWrap":"chat-history_emptyWrap__64_oq","emptyState":"chat-history_emptyState__XBWGR","mobileToolbar":"chat-history_mobileToolbar__8TSnS","mobileListBody":"chat-history_mobileListBody__R2cLx","mobileDetailHeader":"chat-history_mobileDetailHeader__ns1Lx","backBtn":"chat-history_backBtn__010IN"};

/***/ }),

/***/ 7297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ })

}]);